const MobileCover =() =>{
    return (
        <h1>mobile</h1>
    )
}
export default MobileCover